if (!window.customElements.get('tab-list')) {
  class TabList extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[role=tab]').length >= 1 ? Array.from(this.querySelectorAll('[role=tab]')) : [];
      this.firstTab = this.tabs.length ? this.tabs[0] : null;
      this.lastTab = this.tabs.length ? this.tabs.at(-1) : null;
      this.tabpanels = [];
    }

    connectedCallback() {
      this.tabs.forEach((tab) => {
        const tabpanel = document.getElementById(tab.getAttribute('aria-controls'));
        tab.tabIndex = -1;
        tab.setAttribute('aria-selected', 'false');
        if (tabpanel) this.tabpanels.push(tabpanel);
        else this.tabpanels.push(null);
      });

      this.tabs.forEach((tab) => {
        tab.addEventListener('keydown', this.onKeydown.bind(this));
        tab.addEventListener('click', this.onClick.bind(this));
      });

      this.setSelectedTab(this.firstTab, false);
    }

    setSelectedTab(currentTab, setFocus) {
      if (!currentTab) return;

      if (typeof setFocus !== 'boolean') {
        setFocus = true;
      }

      this.tabs.forEach((tab, index) => {
        if (currentTab === tab) {
          tab.setAttribute('aria-selected', 'true');
          tab.removeAttribute('tabindex');

          if (this.tabpanels[index]) {
            this.tabpanels[index].classList.remove('!hidden');
          }

          if (setFocus) {
            tab.focus();
          }
        } else {
          tab.setAttribute('aria-selected', 'false');
          tab.tabIndex = -1;

          if (this.tabpanels[index]) {
            this.tabpanels[index].classList.add('!hidden');
          }
        }
      });
    }

    setSelectedToPreviousTab(currentTab) {
      let index;

      if (currentTab === this.firstTab) {
        this.setSelectedTab(this.lastTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(this.tabs[index - 1]);
      }
    }

    setSelectedToNextTab(currentTab) {
      let index;

      if (currentTab === this.lastTab) {
        this.setSelectedTab(this.firstTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(this.tabs[index + 1]);
      }
    }

    onKeydown(event) {
      let flag = false;

      switch (event.key) {
        case 'ArrowLeft':
          this.setSelectedToPreviousTab(event.currentTarget);
          flag = true;
          break;

        case 'ArrowRight':
          this.setSelectedToNextTab(event.currentTarget);
          flag = true;
          break;

        case 'Home':
          this.setSelectedTab(this.firstTab);
          flag = true;
          break;

        case 'End':
          this.setSelectedTab(this.lastTab);
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    onClick(event) {
      this.setSelectedTab(event.currentTarget);
    }
  }

  window.customElements.define('tab-list', TabList);
}